import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Row, Col, Space,Modal } from "antd";
import { Link , useHistory} from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import KeyOutlined from "@ant-design/icons/lib/icons/KeyOutlined";
import ReCAPTCHA from "react-google-recaptcha";

import { SetWithExpiry,GetWithExpiry,GetSerialProgram } from "../../../util/sessionManager";
import { Login } from "../../../API/Authentication";

const ErrorModal = Modal.error;
const WarningModal = Modal.warning;

const FormItem = Form.Item;

export default function SignIn() {
  const [loadingButton, setLoadingButton] = useState({ loading: false });
  const [SP, setSP]= useState(GetSerialProgram());
  const history = useHistory();

  useEffect(() => {
    import("./index.css");

  }, []);

  const onFinishFailed = (errorInfo) => {ErrorModal({
    title: "خطا",
    content: "مشکلی هنگان انجام عمیلات رخداد"+errorInfo,
    okText: "باشد",
    okType: "danger",
    onOk() {},
  });};

  const onFinish = (values) => {
    setLoadingButton({ loading: true });
    try {
      Login(values)
        .then((i) => {
          console.log("login",i.data,i)
          const response = i;
          if (response.success) {
            SetWithExpiry("user", response, 1000 * 3600);
            console.log(GetWithExpiry("user"));
            
            window.location.replace("../");
          } else {
            WarningModal({
              title: "هشدار",
              content: "کاربری با مشخصات وارد شده یافت نشد",
              okText: "باشد",
              okType: "danger",
              onOk() {},
            });
          }
        })
        .catch((e) => {
          ErrorModal({
            title: "خطا",
            content: e,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });

      // if(values.username=="fathi" && values.password == "Af09140988518"){
      //   SetWithExpiry("user", {name:"فتحی", state: true}, 1000 * 3600);
      //       console.log(GetWithExpiry("user"));
            
      //       window.location.replace("../");
      // }
    } catch (e) {
      ErrorModal({
        title: "خطا",
        content: "مشکلی هنگان انجام عمیلات رخداد",
        okText: "باشد",
        okType: "danger",
        onOk() {},
      });
    }
    setLoadingButton({ loading: false });
  };

  return (
    <Row className="loginPage">
      <Col lg={12} md={24} sm={24} className="loginPageRight">
        <div className="gx-login-container">
          <div className="gx-login-content">
            <div className="gx-login-header">
              <span className="gx-login-title">صلاحیت ورود</span>
            </div>
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
             
              <FormItem
                label="نام کاربری"
                rules={[{ required: true, message: "لطفا ایمیلت رو وارد کن!" }]}
                name="username"
              >
                <Input
                  prefix={
                    <UserOutlined
                      style={{ color: "rgba(0,0,0,.25)" }}
                      className="gx-w-100"
                    />
                  }
                />
              </FormItem>
              <FormItem
                label=" رمز عبور"
                rules={[
                  { required: true, message: "لطفا رمز عبورت رو وارد کن!" },
                ]}
                name="password"
              >
                <Input
                  prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                  type="password"
                />
              </FormItem>
              
              <FormItem
                rules={[
                 
                ]}
                name="reacptcha"
              >
                <ReCAPTCHA sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" />
              </FormItem>
              <FormItem className="gx-text-right loginButton">
                <Button type="primary" htmlType="submit" {...loadingButton}>
                  ورود
                </Button>
              </FormItem>
            </Form>
          </div>
          <Row className="loginLogo">
            <img src={"https://www.sabaapi.com/webapi/visitor/frontEnd/logowhite.png"} />
          </Row>
        </div>
      </Col>
      <Col lg={12} md={0} sm={0} className="loginPageLeft"></Col>
    </Row>
  );
}
